/* eslint-disable import/no-anonymous-default-export */
import BranchSummaryReportTypes from './branch-summary-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	fetchBranchSummaryDetailResponse: null,
	fetchNPADetailArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case BranchSummaryReportTypes.FETCH_BRANCH_SUMMARY_REPORT_SUCCESS:
			return {
				...state,
				getBranchSummaryListResponse: action.payload,
				getBranchSummaryReportListArr: docodeHexResponse(
					action.payload,
					'BranchSummaryReportListKey',
				),
			};
		case BranchSummaryReportTypes.FETCH_BRANCH_SUMMARY_REPORT_FAILURE:
			return { ...state, getBranchSummaryReportListResponse: action.payload };
		case BranchSummaryReportTypes.FETCH_BRANCH_SUMMARY_REPORT_RESPONSE_CHANGED:
			return { ...state, getBranchSummaryReportListResponse: null };
		default:
			return state;
	}
};
